import React from 'react';
import dhruvEmblem from '../../assets/dhruv.png';
import dhruvWordmark from '../../assets/logo.jpe';
import { COMPANY_SHORT_NAME, WORKSPACE_TAGLINE } from '../../config/branding';

/**
 * @param {'wordmark' | 'emblem' | 'emblem-sidebar' | 'emblem-header' | 'emblem-login' | 'loginBrand' | 'stacked'} variant
 */
const BrandLogo = ({
  variant = 'wordmark',
  className = '',
  alt = COMPANY_SHORT_NAME,
  src = ''
}) => {
  if (
    variant === 'emblem'
    || variant === 'emblem-sidebar'
    || variant === 'emblem-shell'
    || variant === 'emblem-header'
    || variant === 'emblem-login'
  ) {
    const sizeClass =
      variant === 'emblem-sidebar'
        ? 'brand-logo-img--emblem-sidebar'
        : variant === 'emblem-shell'
          ? 'brand-logo-img--emblem-shell'
          : variant === 'emblem-header'
            ? 'brand-logo-img--emblem-header'
            : variant === 'emblem-login'
              ? 'brand-logo-img--emblem-login'
              : 'brand-logo-img--emblem';
    return (
      <img
        src={src || dhruvEmblem}
        className={`brand-logo-img ${sizeClass} ${className}`}
        alt={alt}
        decoding="async"
      />
    );
  }

  if (variant === 'loginBrand' || variant === 'stacked') {
    return (
      <div className={`brand-logo-stacked brand-logo-stacked--login ${className}`} aria-label={alt}>
        <BrandLogo variant="emblem-login" alt="" />
        <span className="brand-logo-stacked__title">{COMPANY_SHORT_NAME}</span>
        <span className="brand-logo-stacked__tagline">{WORKSPACE_TAGLINE}</span>
      </div>
    );
  }

  return (
    <img
      src={dhruvWordmark}
      className={`brand-logo-img brand-logo-img--wordmark ${className}`}
      alt={alt}
      decoding="async"
    />
  );
};

export default BrandLogo;
